/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import styled from "styled-components";

import * as API from "../../../../api/manageCatalog";
import Modal from "../../../../components/reusable/reactModal";
import { DeleteConfirmModalPropTypes } from "../lib/types";
import {
  StyledButtonNoMargin,
  StyledErrorMessage,
  StyledModalButtonContainer,
  StyledModalBody,
  StyledModalContents,
} from "../lib/styles";
import { getErrorMessage } from "../lib/helpers";

const StyledError = styled(StyledErrorMessage)`
  margin-top: 14px;
  margin-bottom: 0px;
`;

const DeleteConfirmModal = ({
  catalogItemId,
  closeModal,
  handleFieldChange,
}: DeleteConfirmModalPropTypes): React.ReactElement => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");
  const handleDeleteRewardClick = async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await API.deleteCatalogItem(catalogItemId);
      const { state } = response.data.data;
      handleFieldChange({ state });
      closeModal();
      window.scrollTo(0, 0);
    } catch (error) {
      const message = getErrorMessage(error);
      setError(message);
    }
  };

  return (
    <Modal
      ariaLabel="delete confirm modal"
      close={closeModal}
      showDialog
      testId="delete-confirm-modal"
      title="Delete catalog item?"
    >
      <StyledModalBody>
        <StyledModalContents>
          <p>
            Are you sure you want to remove the catalog item from the global
            reward catalog? This action cannot be undone.
          </p>
        </StyledModalContents>
        <StyledModalButtonContainer>
          <StyledButtonNoMargin
            onClick={closeModal}
            size="small"
            testId="cancel-delete-button"
            variant="secondary"
          >
            Cancel
          </StyledButtonNoMargin>
          <StyledButtonNoMargin
            disabled={loading}
            onClick={handleDeleteRewardClick}
            size="small"
            testId="confirm-delete-button"
            variant="primary"
          >
            Delete reward
          </StyledButtonNoMargin>
        </StyledModalButtonContainer>
        {error && (
          <StyledError data-testid="delete-error-message">{error}</StyledError>
        )}
      </StyledModalBody>
    </Modal>
  );
};

export default DeleteConfirmModal;
